import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import usePost from '../../hooks/usePost';
import useUserById from '../../hooks/useUserById';
import { RiCalendarCheckLine, RiErrorWarningLine, RiVipCrownLine } from 'react-icons/ri';
import useSpots from '../../hooks/useSpots';
import { BiCurrentLocation, BiLike, BiUserVoice } from 'react-icons/bi';
import { MdReport, MdUpdate } from 'react-icons/md';
import { BsFillBookmarkStarFill, BsPaypal, BsPeopleFill } from 'react-icons/bs';
import { GiMoneyStack } from 'react-icons/gi';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase.init';
import { FaGooglePay, FaStar } from 'react-icons/fa';
import { AiOutlineArrowRight } from 'react-icons/ai';
import useUser from '../../hooks/useUser';
import { useState } from 'react';
import { ImCross } from 'react-icons/im';
import { TiWarningOutline } from 'react-icons/ti';
import axios from 'axios';
import { toast } from 'react-toastify';

const SinglePost = ({ id }) => {

    function formatTime(time) {
        const hourString = time?.slice(0, time?.indexOf(':'));
        const minute = time?.slice(time?.indexOf(':') + 1, time?.length);
        const hour = +hourString % 24;
        return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
    }

    const [post, setPost] = usePost(id);
    const [userq] = useUserById(post?.uid);
    const [spots] = useSpots();
    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);

    const getPost = async () => {
        await axios.get(`https://tripaide-server.onrender.com/posts/${id}`)
            .then(res => {
                setPost(res.data);
                //console.log(res.data);
            });
    }

    let navigate = useNavigate();
    const handleUpdatedData = async (newPost) => {
        await axios.put("https://tripaide-server.onrender.com/posts", newPost)
            .then(res => {
                //console.log(res.data);
                //const id = res.data.insertedId;
                getPost(post?.id);
            });
    };

    const [interest, setInterest] = useState(false);
    if (post?.interested?.find(i => i?.id === userc?._id) !== undefined && !interest) {
        setInterest(true);
    }
    const handleInterested = () => {
        if (userc?.email) {
            const updatedData = {
                id: post.id,
                interested: [...post.interested, {
                    id: userc?._id,
                    name: userc?.name
                }]
            };
            handleUpdatedData(updatedData);
        } else {
            navigate('/login');
        }
    }

    const handleReport = () => {
        setReportModal(false);
        if (userc?.email) {
            const updatedData = {
                id: post.id,
                isReported: true,
                reporter: user?.email
            };
            handleUpdatedData(updatedData);
        } else {
            navigate('/login');
        }
    }

    const handleReview = () => {
        toast.error("Featue isn't available right now!");
    }

    const handlePay = () => {
        toast.error("Featue isn't available right now!");
    }

    const handleDeatils = () => {
        navigate(`/details/${id}`);
    }

    const handleFinish = () => {
        const updatedData = {
            id: post.id,
            state: "Finished"
        };
        handleUpdatedData(updatedData);
    }

    const handleStart = () => {
        const updatedData = {
            id: post.id,
            state: "Ongoing"
        };
        handleUpdatedData(updatedData);
    }

    const handleDelete = async (id) => {
        await axios.delete(`https://tripaide-server.onrender.com/posts/${id}`)
            .then(res => {
                if (res.data.deletedCount) {
                    toast.warn("Post is deleted.");
                    getPost(post?.id);
                }
            })
    }

    const handleCancel = () => {
        handleDelete(post?.id);
    }

    const [job, setJob] = useState(false);
    if (post?.job?.find(i => i?.id === userc?._id) !== undefined && !job) {
        setJob(true);
    }
    const handleApply = () => {
        const updatedData = {
            id: post.id,
            job: [...post.job, {
                id: userc?._id,
                name: userc?.name
            }]
        };
        handleUpdatedData(updatedData);
    }

    const [reportModal, setReportModal] = useState(false);

    return (
        <div className='w-full bg-gray-100 p-8 my-8 rounded-xl shadow-custom-lg'>
            <div className='flex justify-between mb-4'>
                <div className='cursor-pointer flex items-center bg-trans px-2 text-yellow-500 rounded font-medium text-sm'>
                    <RiVipCrownLine className='mr-1' />
                    <span>{post?.type}</span>
                </div>
                {
                    post?.state !== "Finished" && userq?.email !== user?.email && <div>
                        {
                            post?.isReported === true ? (
                                <div className='cursor-pointer flex items-center bg-red-300 px-2 text-gray-900 rounded font-medium text-sm'>
                                    <MdReport className='mr-1' />
                                    <span>Reported</span>
                                </div>
                            ) : (
                                <div onClick={() => setReportModal(true)} className='cursor-pointer flex items-center bg-gray-300 px-2 text-red-500 rounded font-medium text-sm'>
                                    <MdReport className='mr-1' />
                                    <span>Report</span>
                                </div>
                            )
                        }
                    </div>
                }
                {
                    reportModal && <div>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-auto my-6 mx-auto max-w-sm">
                                {/*content*/}
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    {/*header*/}
                                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                                        <h3 className="flex items-center text-xl font-semibold">
                                            <TiWarningOutline className='text-red-500 mr-3' />Are you sure?
                                        </h3>
                                    </div>
                                    {/*body*/}
                                    <div className="relative p-6 flex-auto">
                                        <p className="my-4 text-slate-500 text-lg leading-relaxed">
                                            Does this post speard nudity, false information, or hate speech?
                                        </p>
                                    </div>
                                    {/*footer*/}
                                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                                        <button
                                            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setReportModal(false)}
                                        >
                                            Close
                                        </button>
                                        <button
                                            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleReport}
                                        >
                                            Yes, I Agree
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                }
            </div>
            <div className='md:flex justify-between font-semibold'>
                <div className='md:flex items-center'>
                    <p className='text-sm'>Posted By</p>
                    <Link className='ml-2 text-lg text-pink-600 block' to={`/u/${post?.uid}`}>{post?.owner}</Link>
                    <div className='hidden md:flex items-center justify-start text-sm ml-4'>
                        <BsFillBookmarkStarFill className='text-yellow-500' />
                        <p className='font-semibold pl-1'>{userq?.rating}</p>
                    </div>
                </div>
                {
                    post?.state === "Running" && <div className='h-6 bg-trans text-white px-2 rounded inline-flex items-center cursor-pointer'>
                        <div className="w-3 h-3 rounded-full animate-pulse bg-green-400"></div>
                        <p className='ml-2 text-sm text-green-500'>{post?.state}</p>
                    </div>
                }
                {
                    post?.state === "Ongoing" && <div className='bg-trans text-white px-2 rounded flex items-center cursor-pointer'>
                        <div className="w-3 h-3 rounded-full animate-pulse bg-sky-400"></div>
                        <p className='ml-2 text-sm text-sky-500'>{post?.state}</p>
                    </div>
                }
                {
                    post?.state === "Finished" && <div className='bg-trans text-white px-2 rounded flex items-center cursor-pointer'>
                        <div className="w-3 h-3 rounded-full animate-pulse bg-gray-400"></div>
                        <p className='ml-2 text-sm text-gray-500'>{post?.state}</p>
                    </div>
                }
            </div>
            <div className='flex items-center text-2xl font-bold mt-2'>
                <BiCurrentLocation className='text-yellow-700' />
                <p className="ml-2">{post?.place}, {post?.spot}</p>
            </div>
            <div className='flex items-center'>
                <div className='flex items-center'>
                    <RiCalendarCheckLine className='text-yellow-700' />
                    <p className="text ml-2">{post?.date}</p>
                </div>
                <div className='flex items-center text-sm font-medium bg-pink-500 px-2 rounded text-white ml-4'>
                    <MdUpdate className='' />
                    <p className="ml-1">{formatTime(post?.time)}</p>
                </div>
            </div>
            <div className='text-sm pt-4'>
                <p><span className='font-bold text-yellow-600'>Description : </span>{post?.text}</p>
            </div>
            <div className='font-semibold pt-4'>
                <p><span className='font-bold text-yellow-600'>Duration : </span>{post?.days} Days</p>
            </div>
            {
                post?.guide !== "" &&
                <div className='font-semibold pt-4'>
                    <p><span className='font-bold text-yellow-600'>Guide : </span><Link to={`/u/${post?.guideId}`} className='text-sm font-medium bg-violet-500 px-2 rounded text-white ml-4'>{post?.guide}</Link></p>
                </div>
            }
            <div className='flex pt-4'>
                <div className='flex items-center text-sm font-medium bg-lime-600 px-2 rounded text-white mr-8'>
                    <BsPeopleFill />
                    <p className="ml-1">{post?.member} Persons</p>
                </div>
                <div className='flex items-center text-sm font-medium bg-sky-500 px-2 rounded text-white'>
                    <GiMoneyStack />
                    <p className="ml-1">{post?.budget} BDT</p>
                </div>
            </div>
            <div className='flex my-4'>
                <div className='flex items-center text-sm font-medium bg-yellow-500 px-2 rounded text-white mr-8'>
                    <FaStar />
                    <p className="ml-1">Interested : {post?.interested?.length - 1}</p>
                </div>
            </div>
            <div className='flex flex-wrap'>
                {
                    !job && !interest && post?.state === "Running" && userq?.email !== user?.email && <div className='inline-flex'>
                        <div onClick={handleInterested} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BiLike className='text-lg' />
                            <p className='ml-2'>Show Interest</p>
                        </div>
                    </div>
                }
                {
                    post?.state === "Running" && userq?.email === user?.email && <div className='inline-flex'>
                        <div onClick={handleDeatils} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BiLike className='text-lg' />
                            <p className='ml-2'>View Details</p>
                        </div>
                    </div>
                }
                {
                    interest && post?.state === "Running" && userq?.email !== user?.email && <div className='inline-flex'>
                        <div className='mr-8 bg-trans text-yellow-500 py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BiLike className='text-lg' />
                            <p className='ml-2'>Interested</p>
                        </div>
                    </div>
                }
                {
                    interest && post?.state === "Ongoing" && userq?.email !== user?.email && <div className='inline-flex'>
                        <div onClick={handlePay} className='mr-8 bg-yellow-600 text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BsPaypal className='text-lg' />
                            <p className='ml-2'>Down Pay</p>
                        </div>
                    </div>
                }
                {
                    post?.state === "Finished" && userq?.email === user?.email && <div className='inline-flex'>
                        <div onClick={handleReview} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <p className='mr-2'>Review</p>
                            <AiOutlineArrowRight className='text-lg' />
                        </div>
                    </div>
                }
                {
                    post?.state === "Ongoing" && userq?.email === user?.email && <div className='inline-flex'>
                        <div onClick={handleFinish} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <p className='mr-2'>Finish Tour</p>
                            <AiOutlineArrowRight className='text-lg' />
                        </div>
                    </div>
                }
                {
                    post?.state === "Running" && userq?.email === user?.email && <div className='inline-flex'>
                        <div onClick={handleStart} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <p className='mr-2'>Start Tour</p>
                            <AiOutlineArrowRight className='text-lg' />
                        </div>
                    </div>
                }
                {
                    post?.state === "Running" && userq?.email === user?.email && <div className='inline-flex'>
                        <div onClick={handleCancel} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <p className='mr'>Cancel Tour</p>
                        </div>
                    </div>
                }
                {
                    !interest && !job && post?.state === "Running" && userq?.email !== user?.email && userc?.role === "guide" && <div className='inline-flex'>
                        <div onClick={handleApply} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BiUserVoice className='text-lg' />
                            <p className='ml-2'>Apply</p>
                        </div>
                    </div>
                }
                {
                    job && post?.state === "Running" && userq?.email !== user?.email && userc?.role === "guide" && <div className='inline-flex'>
                        <div className='mr-8 bg-trans text-yellow-500 py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                            <BiUserVoice className='text-lg' />
                            <p className='ml-2'>Applied</p>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default SinglePost;